import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'alertCounter'
})
export class AlertCounterPipe implements PipeTransform {
  transform(value: number): string {
    let count: string;
    if (!!value) {
      count = value > 99 ? '99+' : value.toString();
    }

    return count;
  }
}
